const AjaxPost = ( fileName, data, callback ) => {

    let xmlhttp, returnText

    if ( window.XMLHttpRequest ) {
        xmlhttp = new XMLHttpRequest()
    } else  {
        alert("Sorry, Your browser is too old...")
    }

    xmlhttp.open( 'post', fileName, true )
    // xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    xmlhttp.onload = function() {
        if ( xmlhttp.readyState === 4 && xmlhttp.status === 200 ){
            returnText = xmlhttp.responseText
            setTimeout( function(){
                if ( callback ){
                    callback( returnText )
                }
            }, 10)
        }
    }

    xmlhttp.send( data )
}

export default AjaxPost


// WEBPACK FOOTER //
// ./src/components/AjaxPost/AjaxPost.js